module.exports = __webpack_public_path__ + "static/media/Kessel105-Bold.df94b6fb.woff";